import React from 'react';
import PropTypes from 'prop-types';
import AIconButton from '../atoms/_atoms.icon-button';

export default function MProductCompare({
	title,
	img,
	description,
	onClose,
}) {
	return (
		<section className="m-product-compare">
			<header>
				<h3>{title}</h3>
				<AIconButton
					type="close"
					className="no-color"
					onClick={onClose}
				/>
			</header>
			<figure>
				<img src={img} alt="" />
			</figure>
			<article className="product-compare--text">
				<div dangerouslySetInnerHTML={{ __html: description }} />
			</article>
		</section>
	);
}

MProductCompare.propTypes = {
	title: PropTypes.string.isRequired,
	img: PropTypes.string.isRequired,
	description: PropTypes.string.isRequired,
	onClose: PropTypes.func,
};

MProductCompare.defaultProps = {
	onClose: undefined,
};



// WEBPACK FOOTER //
// ./src/components/molecules/_molecules.product-compare.js